<style>

input[type="text"]{
  background-color: inherit;
  border: 0;
  border-radius: 0;
  border-bottom: 2px white solid;
  color: white;
  background-color: rgba(255,255,255,0.2);
}

.bg{
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-image: url("/i/signup-bg-wizard.jpg");
  background-size: cover;
  color: black;
  padding: 20px;
  overflow-y: scroll;
}

.margin{
  margin-top: 50px;
}
</style>

<div class="bg">
  <div class="title-signup">What's your phone number?</div>
  <div class="margin">
    <ValidInput bind:value="{phone}" pattern="[0-9]*" valid="{valid}" on:changed="{check}"></ValidInput>
  </div>
  <!-- <div class="margin small">We'll send you a text message with a code to verify your phone number.</div> -->
  <div class="margin small">Phone number verification coming soon.</div>
  
  <div class="has-buttons"></div>
  
</div>

<!-- <div class="next">
  <button on:click="{next}" disabled="{nextDisabled}">Next</button>
</div> -->
<NextButton on:click="{next}" disabled="{nextDisabled}"></NextButton>

<script>

import {push, pop, replace, location, link} from 'svelte-spa-router';

import ValidInput from "../../../../components/ValidInput.svelte";
import NextButton from "../../../../components/NextButton.svelte";

import Signup from "../../../../helpers/Signup.js";
import Validate from "../../../../helpers/Validate.js";
import Normalize from "../../../../helpers/Normalize.js";

import { onMount } from "svelte";
onMount(async () => {
  try {
    Signup.verifyPersonalObject();
  } catch (e) {
    console.log("error:", e);
    
    if (e == "Must start from beginning") {
      document.location = "/";
    }
    
    return;
  }
  
  // if signup is already complete, then we push the user outta here...
  let signupComplete = Signup.getPersonalObject("signupComplete");
  if (signupComplete == true) {
    document.location = "/";
    return;
  }
  
  allowSignup = true;
  // Signup.saveToPersonalObject("phone", "");
  phoneSaved = Signup.getPersonalObject("phoneSaved");
  phone = Signup.getPersonalObject("phone");
  
  if (phoneSaved == true) {
    valid = true;
    nextDisabled = false;
  } else {
    check();
  }
  
});

let allowSignup = false;
let phone = "213-555-5555";
let phoneSaved = false;
let valid = false;
let nextDisabled = true;
let signupDelayHandle = null;
let lastPhone = "";


function check(e) {
  clearTimeout(signupDelayHandle);
  
  if (phone == lastPhone) return;
  
  phoneSaved = false;
  
  signupDelayHandle = setTimeout( async () => {
    lastPhone = phone;
    try {
      Validate.allowSignup(allowSignup);
      Validate.phone(phone);
      valid = true;
      nextDisabled = false;
    } catch (e) {
      valid = false;
      nextDisabled = true;
      console.log("error:", e);
    }
  }, 450);
  
}


async function next() {
  if (phoneSaved == false) {
    phone = Normalize.phone(phone);
    await Signup.saveToPersonalObject("phone", phone);
    await Signup.saveToPersonalObject("phoneSaved", true);
    await Signup.savePhone();
    await Signup.saveMe("phone");
  }
  
  // once we have text message verification setup, we'll go to phone-verify
  // for now, we skip it...
  // push("/signup/profile/personal/phone-verify");
  push("/signup/profile/personal/username");
  
}


</script>